import { render, staticRenderFns } from "./MedicalRecordTable.vue?vue&type=template&id=544cc5ab&"
import script from "./MedicalRecordTable.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports